import React from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import EmpresaPage from "./pages/EmpresaPage";
import { CartProvider } from "./context/CartContextCliente";

function EmpresaPageWithCart() {
  const { empresaSlug } = useParams();
  console.log("empresaSlug actual:", empresaSlug);

  return (
    <CartProvider storageKey={`cart_${empresaSlug}`}>
      <EmpresaPage />
    </CartProvider>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:empresaSlug" element={<EmpresaPageWithCart />} />
      </Routes>
    </Router>
  );
}

export default App;